import React, { useEffect, useState } from "react";
import axios from "axios";
import toastr from "toastr";
import { Link } from "react-router-dom";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
// import Loading from "../Loading/Loading";

export default function DisReturnTable() {
  const authToken = localStorage.getItem("disToken");
  const [returnList, setReturnList] = useState([]);

  useEffect(() => {
    getAllReturns();
  }, [authToken]);

  async function getAllReturns() {
    try {
      const response = await axios.get(
        `http://api.meddaily.in/get_all_return`,
        {
          headers: {
            token: authToken,
          },
        }
      );
      console.log(response);
      if (response.status === 200) {
        setReturnList(response?.data?.data);
      }
    } catch (err) {
      toastr.error(err?.response?.data?.message);
      console.log(err);
    }
  }

  
  return (
    <>
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          {/* <Sidebar /> */}

          <div className="layout-page">
            {/* <Navbar /> */}

            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row">
                  <div className="card">
                    <h5 className="card-header">Return Table</h5>
                    <div className="table-responsive text-nowrap">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>Order ID</th>
                            <th>Vendor Name</th>
                            <th>Return Amount</th>
                            <th>Quantity</th>
                            <th>View More</th>
                          </tr>
                        </thead>
                        <tbody className="table-border-bottom-0">
                          {returnList && returnList.length > 0 ? (
                            <tr>
                              <td>
                                <i className="fab fa-angular fa-lg text-danger me-3"></i>{" "}
                                {returnList.order_id || "NA"}
                              </td>
                              <td>{returnList.name || "NA"}</td>
                              <td>{returnList.price || 0}</td>
                              <td>{returnList.quantity || 0}</td>
                              <td>
                                <div className="dropdown">
                                  <Link className="dropdown-item" to="/returorderdetails">
                                    {" "}
                                    View Full Details
                                  </Link>
                                </div>
                              </td>
                            </tr>
                          ) : (
                            // <Loading />
                            <>
                              <tr>
                                <td colSpan="5" style={{ textAlign: "center" }}>
                                  <p>No Products are availabe for return</p>
                                </td>
                              </tr>
                            </>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div className="content-backdrop fade"></div>
              </div>
            </div>
          </div>

          <div className="layout-overlay layout-menu-toggle"></div>
        </div>
      </div>
    </>
  );
}
